import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  Node,
  CoreLink,
} from '@uncinc/react-drupal-core';

import './style.scss';

const LandingSelectedEntities = ({ id, type, link, entities, title }) => {
  const { t } = useTranslation();

  return (
    <div className="LandingSelectedEntities">
      <Container id={id}>
        <div className="row">
          <div className="col-12 SelectedReadmore__wrapper">
            <h2>{title}</h2>
            <CoreLink to={link} className="SelectedReadmore Paragraph__readmore">
              {t('general.view_all')} {t(`entities.${type}`).toLowerCase()}
              <span className="icon icon-arrow-right icon-variant-2" />
            </CoreLink>
          </div>
        </div>
        <div className="row rendered_content">
          {entities.map((record, index) => {
            let ent = record.get('entity');
            if (!ent) {
              ent = record;
            }
            const id = ent.getIn(['nid', 0, 'value']);
            const uuid = ent.getIn(['uuid', 0, 'value']);

            if (index === 0) {
              return (
                <div key={uuid} className="col-12">
                  <Node
                    id={id}
                    entity={ent}
                    viewMode="teaser"
                    large
                  />
                </div>
              );
            }
            return (
              <div key={uuid} className="col-12 col-md-6 col-lg-4">
                <Node
                  id={id}
                  entity={ent}
                  viewMode="teaser"
                  large={false}
                />
              </div>
            );
          })}
        </div>
        <div className="row">
          <div className="col-12">
            <CoreLink to={link} className="SelectedReadmore Paragraph__readmore_mb">
              {t('general.view_all')} {t(`entities.${type}`).toLowerCase()}
              <span className="icon icon-arrow-right icon-variant-2" />
            </CoreLink>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default LandingSelectedEntities;
